import { TabNav as RadixTabNav } from '@radix-ui/themes';

type TabsSize = '1' | '2' | '3';

export type TabsNavProps = Omit<
  RadixTabNav.RootProps,
  'size' | 'color' | 'children'
> & {
  size?: TabsSize;
  tabs: TabNav[];
};

export type TabNav = {
  label: React.ReactNode;
  /** Stable automation id; when omitted, derived from label (lowercased string form). */
  dataTestId?: string;
  to?: string;
  href?: string;
  disabled?: boolean;

  iconStart?: React.ReactNode | string;
  iconEnd?: React.ReactNode | string;
  iconStartSize?: number;
  iconEndSize?: number;

  active?: (pathname: string) => boolean;
};

export const sizeToRadixTabsSizeMap: Record<
  TabsSize,
  RadixTabNav.RootProps['size']
> = {
  '1': '1',
  '2': '2',
  '3': '2',
};

export const sizeToTabMap: Record<TabsSize, string> = {
  '1': 'text-size-fly-1',
  '2': 'text-size-fly-2',
  '3': 'text-size-fly-2',
};
